module.exports = __webpack_public_path__ + "img/text-classify2.2b195576.png";